module.exports = __webpack_public_path__ + "static/media/frontend.69ced872.png";